// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2-Evt","title":"Images45_title__1YqO1","images":"Images45_images__1HbEJ"};